import { controller, HoverLabel, Selects } from './form'
import {
    setupModals,
    Header,
    PageList,
    // Accordions,
    gmap,
    SetupVideos,
    SetupAutoPlayVideos,
    ScrollAnim,
    AppScreens,
    // Enquire,
    LogoColor,
    ScrollFade,
    Paralax,
    ScrollUp,
    GridAnim,
    VenCircles,
    SmoothScroll,
    ProgressiveHover,
    BannerAlert,
    LetsTalk,
    Newsletter,
    Popup,
    Showcase
} from './ui'
import { waitAnimationFrame } from './util'
import lazySizes from 'lazysizes'
import { listen } from 'quicklink'

function init() {
    document.body.classList.remove('preload')
    document.body.classList.add('loaded') // trigger css to know js has loaded

    // wait for style update from .loaded class
    waitAnimationFrame(() => {
        // Accordions()
        sliders()
        // listingSlider()
        Header()
        setupModals()
        forms()
        Selects()
        PageList()
        gmap()
        SetupVideos()
        SetupAutoPlayVideos()
        HoverLabel()
        // Enquire()
        ScrollFade()
        ScrollUp()
        Paralax()
        LogoColor()
        AppScreens()
        ScrollAnim(['.u-header-line', '.u-scroll-anim', 'h2:not([class])'])
        GridAnim()
        VenCircles()
        SmoothScroll()
        ProgressiveHover()
        BannerAlert()
        LetsTalk()
        Newsletter()
        Popup()
        Showcase()

        // if (!window.isLoggedIn) {
        //     listen()
        // }
    })
}

if (document.readyState !== 'loading') {
    init()
} else {
    document.addEventListener('DOMContentLoaded', init)
}

function forms() {
    const formEls = document.querySelectorAll('.js-form')
    const forms = Array.from(formEls)
    forms.forEach((el) => controller(el))
}

// function initSW() {
//     // if (window.location.hostname === 'localhost') {
//     //     return
//     // }
//     if ('serviceWorker' in navigator) {
//         // navigator.serviceWorker
//         //     .getRegistrations()
//         //     .then(function (registrations) {
//         //         for (let registration of registrations) {
//         //             registration.unregister()
//         //         }
//         //     })
//         //     .catch(function (err) {
//         //         console.log('Service Worker registration failed: ', err)
//         //     })
//         navigator.serviceWorker.register('/sw.js').then(
//             function (registration) {
//                 registration.active.postMessage({
//                     isLoggedIn: window.isLoggedIn
//                 })

//                 // Registration was successful
//                 console.log(
//                     'ServiceWorker registration successful with scope: ',
//                     registration.scope
//                 )
//             },
//             function (err) {
//                 // registration failed
//                 console.log('ServiceWorker registration failed: ', err)
//             }
//         )
//     }
// }

function sliders() {
    const genericSliderEls = document.querySelectorAll('.js-slider')
    const listingSliderEls = document.querySelectorAll('.js-listing-slider')

    if (genericSliderEls.length || listingSliderEls.length) {
        import('./ui/slider')
            .then((m) => m.Slider)
            .then((Slider) => {
                genericSlider(Slider, genericSliderEls)
                listingSlider(Slider, listingSliderEls)
            })
    }
}

function genericSlider(Slider, els) {
    if (!els || !els.length) {
        return
    }
    const sliders = Array.from(els)
    sliders.forEach((el) => {
        let { dots, slidesToShow, slidesToScroll, autoplay } = el.dataset
        dots = dots !== 'false'
        autoplay = autoplay === 'true'
        slidesToShow = +slidesToShow || 1
        slidesToScroll = +slidesToScroll || 1
        let responsive = {}
        if (slidesToShow === 4) {
            slidesToShow = 2
            slidesToScroll = 2

            responsive = {
                '1024px': {
                    slidesToShow: 4,
                    slidesToScroll: 4
                }
            }
        }

        Slider(el, {
            options: {
                slidesToShow,
                slidesToScroll,
                arrows: false,
                referenceArrows: true,
                autoplay,
                dots,
                infiniteSlide: true,
                horizontalSlide: true,
                pauseOnHover: true,
                dotFormat: () => '<span></span>',
                responsive
            },
            classes: {
                slider: 'c-slider',
                viewport: 'c-slider__viewport',
                track: 'c-slider__track',
                slide: 'c-slider__slide',
                slideClone: 'c-slider__slide--clone',
                nextArrow: 'c-slider__arrow--next',
                prevArrow: 'c-slider__arrow--prev',
                dotList: 'c-slider__dots',
                dot: 'c-slider__dot'
            }
        })
    })
}

function listingSlider(Slider, els) {
    if (!els || !els.length) {
        return
    }
    const listingSliders = Array.from(els)
    listingSliders.forEach((el) => {
        let { dots, slidesToShow } = el.dataset
        dots = dots !== 'false'
        slidesToShow = +slidesToShow || 1

        let responsive = {}

        if (slidesToShow === 4) {
            responsive = {
                '768px': {
                    slidesToShow: 2
                },
                '1024px': {
                    slidesToShow: 4
                }
            }
        }

        if (slidesToShow === 3) {
            responsive = {
                '1024px': {
                    slidesToShow: 3
                }
            }
        }

        if (slidesToShow === 2) {
            responsive = {
                '1024px': {
                    slidesToShow: 2
                }
            }
        }

        window.slider = Slider(el, {
            options: {
                slidesToShow: 1,
                arrows: true,
                referenceArrows: true,
                dots,
                infiniteSlide: true,
                horizontalSlide: true,
                dotFormat: () => '<span></span>',
                responsive
            },
            classes: {
                slider: 'o-slider',
                viewport: 'o-slider__viewport',
                track: 'o-slider__track',
                slide: 'o-slider__slide',
                slideClone: 'o-slider__slide--clone',
                nextArrow: 'o-slider__arrow--next',
                prevArrow: 'o-slider__arrow--prev',
                dotList: 'o-slider__dots',
                dot: 'o-slider__dot'
            }
        })
    })
}
